export function toE164(phoneCode: string, phoneNumber: string): string | null {
  const code = phoneCode.replace(/\D/g, "");
  const number = phoneNumber.replace(/\D/g, "");
  const e164 = `+${code}${number}`;

  return /^\+\d{1,15}$/.test(e164) ? e164 : null;
}

export function toE164FromString(
  phone: string | null | undefined
): string | null {
  if (!phone || !phone.trim()) {
    return null;
  }

  const cleanedPhone = phone.replace(/[^\d+]/g, "");
  const formattedPhone = cleanedPhone.startsWith("+")
    ? cleanedPhone
    : `+${cleanedPhone}`;

  if (/^\+\d{1,15}$/.test(formattedPhone)) {
    return formattedPhone;
  }

  return null;
}
